import { RawCollection, ResourceType } from '../types';

export const getResourceCollections = (resource: { id: string; type: ResourceType }, collections: RawCollection[]) =>
    collections.filter((collection) =>
        collection.items.some((item) => item.resourceId === resource.id && item.resourceType === resource.type)
    );
